var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images"},_vm._l((_vm.images),function(image){return _c('img',{key:image,staticClass:"card-logos",attrs:{"src":require(`@/assets/${image}-logo.svg`),"alt":"card-logos"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }